(ns fen.theme
  "The colours the window uses, and what each of them is for. Here rather
  than in one of the screens, because several of them need the same ones and
  none owns them.

  A terminal's palette, not a form's: near-black behind everything, one
  colour per kind of thing, and the kind is what the colour says. A key is
  green, a reference is cyan, what kind of entity something is is violet,
  what came with the program is amber, and what would take something away
  is red. The window does not know what an entity is - but it knows a key
  from a value and a reference from a note, and that is enough to colour
  by (see fen.screen)."
  )

(def colors
  {:bg     "#0a0d12"
   :panel  "#0e131a"
   :fg     "#c9d4de"
   :dim    "#5f6f80"
   :line   "#1b2431"
   :cursor "#121a25"
   :hover  "#0f151d"
   :key    "#7ee787"
   :ref    "#5ed3f3"
   :kind   "#d2a8ff"
   :seed   "#e3b341"
   :warn   "#ff7b72"})

(def font
  "The one typeface. A real coding face where there is one, the system's
  monospace where there is not - a phone has none of the named ones and
  loses nothing."
  "\"JetBrains Mono\", \"Fira Code\", \"Cascadia Code\", \"SF Mono\", Menlo, Consolas, ui-monospace, monospace")
